export default __webpack_public_path__ + "static/media/close.bc4599ef.svg";